import { Zodios } from "@zodios/core";
import http from "../axiosInstance";
import endpoints from "./api";

export const apiClient = new Zodios(endpoints, {
  axiosInstance: http,
  validate: "none",
});
